module.exports = __webpack_public_path__ + "static/about-image-7b594ee3c32943ae6c45ce8f7337a688.png";